import { OverlayTrigger, ProgressBar, Tooltip } from "react-bootstrap";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import TitleLogoComponent from "../Misc/TitleLogo/TitleLogoComponent";
import TitleTagsComponent from "../Misc/TitleTags/TitleTagsComponent";
import { truncatedDescription } from "../../../utils/AppUtils";
import Dropdown from "react-bootstrap/Dropdown";
import "./ProductCardComponent.scss";
import FormButtonComponent from "../FormControl/FormButton/FormButtonComponent";
import { RightArrowIcon } from "../../../utils/SvgComps";
import ImageComponent from "../../Layouts/ImageComponent";
import _ from "lodash";
import { useSelector } from "react-redux";
import "./ProductCardComponent.scss"
import { useEffect } from "react";

const ProductCardLpDetail = (props) => {

    const {
        id, title, logoAltText, logoURL, bannerURL,
        tagsArray, descAction, description, btnTitle,
        btnAction, bannerAction, footerLineComp, showUpdatedTag,
        showHeader, showBody, showFooter, leftBtnIcon, rightBtnIcon,
        cardClassName, isLoading, progress, duration,
        showProgress, showBtn, isLock, showPlayButton, showProviderIcon, lastKey, refInfo, showLikeMenu, tooltip, is_checklist_approved,
        checklist_approved_by, is_checklist_present, is_learn_more, setShowCL, setCheckListLp, clInfo
    } = props;

    const userDetails = useSelector(state => state.user.userBroker);

    const renderMainComp = () => {
        return (
            <>

                <div className="modulesection "
                    id={`course-lp-${id}`}
                    title={tooltip}>

                    <h3>{title}</h3>
                    <div className="d-flex box-meta">

                        <div className="img-box-meta">

                            <TitleLogoComponent
                                logoURL={logoURL}
                                altText={""}
                                isLoading={false}
                            />
                        </div>
                        <div className="meta-lsit">
                            <TitleTagsComponent
                                tagsArray={tagsArray}
                                isLoading={isLoading}
                            />
                        </div>
                    </div>
                    <div className="image-blocklp">
                        <ImageComponent
                            thumbnail={
                                bannerURL ? bannerURL : ""
                            }
                            name={title}
                            cssClass={`img-fluid galleryImg ${isLock ? "grayscale" : ""
                                }`}
                            errorClass={`img-fluid grayscale d-flex justify-content-center align-items-center bk-grey ${isLock ? "grayscale" : ""
                                }`}
                            handleClick={bannerAction}
                        />
                        {showUpdatedTag ? <div className="new-tag"><span className="new-tag-ribbon">Updated</span></div> : ""}
                        <div className="d-flex justify-content-between align-items-center position-absolute info-btm-pcard">
                        {is_checklist_approved ? <div class="approvedbysec">
                            <div class="fgf">
                                <p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(41,45,50,1)"><path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"></path></svg> Approved By: {checklist_approved_by}</p>
                            </div>
                        </div> : is_checklist_present ? <div class="approvedbysec">
                            <div class="fgf">
                                <p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(41,45,50,1)"><path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"></path></svg> 
                                Approver: {(userDetails?.payload?.payload?.manager && userDetails?.payload?.payload?.manager != ' ') ? userDetails?.payload?.payload?.manager : "Admin"}</p>
                            </div>
                        </div> : ""
                        }
                        {(is_checklist_present) ?
                            <span className={`checklistingo cursor-pointer`} onClick={() => {
                                setShowCL(true);
                                setCheckListLp(clInfo)
                            }} title="Checklist">
                                <img src="/images/checklist.png" width={32} height={32} />
                            </span>
                            : ""}
                    </div>
                    </div>

                    <OverlayTrigger
                        key="bottom"
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-bottom`}>
                                <div
                                    style={{
                                        color: "white",
                                        backgroundColor: "black",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: description,
                                    }}
                                ></div>
                            </Tooltip>
                        }
                    >
                        {description !== undefined ? <p
                            dangerouslySetInnerHTML={{
                                __html:
                                    description?.length <= 170
                                        ? description
                                        : description?.substring(0, 159) + "...",
                            }}
                        ></p> : <p></p>}
                    </OverlayTrigger>
                   

                    <div className="progress-rowsec">
                        {showProgress && <div className="d-flex gap-3 progress-content position-relative">
                            <div className="progress-rowbar">
                                <div
                                    className="progress"
                                    role="progressbar"
                                    aria-label="Basic example"
                                    aria-valuenow={progress}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    <div
                                        className="progress-bar"
                                        style={{ width: progress + "%" }}
                                    ></div>
                                </div>
                            </div>
                            <span className="progress-text">
                                {_.isNumber(progress) ? progress : progress?.split(".")[0]}%
                            </span>
                        </div>}

                        {showBtn && <>
                            <div className="price-sec-xl">
                                {footerLineComp}
                            </div>

                            <button
                                type="button"
                                className={isLock ? 'locked-btn-b2c' : 'startcourse-btn'}
                                onClick={btnAction}
                            >
                                {isLock && <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                    <path opacity="0.12" d="M4.5 15.8C4.5 14.1198 4.5 13.2798 4.82698 12.638C5.1146 12.0735 5.57354 11.6146 6.13803 11.327C6.77976 11 7.61984 11 9.3 11H15.7C17.3802 11 18.2202 11 18.862 11.327C19.4265 11.6146 19.8854 12.0735 20.173 12.638C20.5 13.2798 20.5 14.1198 20.5 15.8V16.2C20.5 17.8802 20.5 18.7202 20.173 19.362C19.8854 19.9265 19.4265 20.3854 18.862 20.673C18.2202 21 17.3802 21 15.7 21H9.3C7.61984 21 6.77976 21 6.13803 20.673C5.57354 20.3854 5.1146 19.9265 4.82698 19.362C4.5 18.7202 4.5 17.8802 4.5 16.2V15.8Z" fill="black" />
                                    <path id="lcked" d="M17.5 11V8C17.5 5.23858 15.2614 3 12.5 3C9.73858 3 7.5 5.23858 7.5 8V11M9.3 21H15.7C17.3802 21 18.2202 21 18.862 20.673C19.4265 20.3854 19.8854 19.9265 20.173 19.362C20.5 18.7202 20.5 17.8802 20.5 16.2V15.8C20.5 14.1198 20.5 13.2798 20.173 12.638C19.8854 12.0735 19.4265 11.6146 18.862 11.327C18.2202 11 17.3802 11 15.7 11H9.3C7.61984 11 6.77976 11 6.13803 11.327C5.57354 11.6146 5.1146 12.0735 4.82698 12.638C4.5 13.2798 4.5 14.1198 4.5 15.8V16.2C4.5 17.8802 4.5 18.7202 4.82698 19.362C5.1146 19.9265 5.57354 20.3854 6.13803 20.673C6.77976 21 7.61984 21 9.3 21Z" stroke="#6941C6" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>}
                                {btnTitle}
                                {!isLock && <RightArrowIcon />}
                            </button>
                        </>}
                    </div>
                </div>







            </>
        )
    }

    return (
        <>


            {
                lastKey ?
                    <div ref={refInfo} className={` mb-botm col ${is_learn_more ? 'col-lg-8 col-lg-offset-2' : 'col-lg-12'} ${lastKey ? 'last-key' : ''} ${cardClassName ? cardClassName : ''}`}>
                        {renderMainComp()}
                    </div>
                    :
                    <div className={` mb-botm col ${is_learn_more ? 'col-lg-8 col-lg-offset-2' : 'col-lg-12'} ${cardClassName ? cardClassName : ''}`}>
                        {renderMainComp()}
                    </div>
            }


        </>
    );
};

export default ProductCardLpDetail;
